module.exports = __webpack_public_path__ + "media/images/massage/cover-desktop@3x-baf03489d6a7d31411bd6e629b617010.jpg";